<template>
      <crud-delete :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @delete="remove"
                 @close="$emit('close')"
    >

        <v-card-text>
          <deuda-show-data :item="item" />
        </v-card-text>

        <v-card-text>
            <v-row justify="center">
                <span class="title">{{areYouSure}}</span>
            </v-row>
        </v-card-text>

    </crud-delete>
</template>

<script>
    //Provider
    import DeudaProvider from "../../../../providers/DeudaProvider";

    //Show Data
    import DeudaShowData from "../DeudaShow/DeudaShowData";

    //Common
    import {CrudDelete, ClientError} from '@dracul/common-frontend'

    export default {
        name: "DeudaDelete",

        components: {DeudaShowData, CrudDelete},

        props: {
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                modal: false,
                title: 'cobrox.deuda.deleting',
                areYouSure: this.$t('common.areYouSureDeleteRecord'),
                errorMessage: '',
                loading: false,
            }
        },
        methods: {
            remove() {
                this.loading = true
                DeudaProvider.deleteDeuda(this.item.id).then(result => {
                            if (result.data.deleteDeuda.success) {
                                this.$emit('itemDeleted',result.data.deleteDeuda)
                                this.$emit('close')
                            }else{
                                this.errorMessage = 'Error on Delete'
                            }
                        }
                    ).catch(error =>{
                        let clientError = new ClientError(error)
                        this.errorMessage = clientError.message
                }).finally(() => this.loading = false)
            },
        },
    }
</script>


